/**
 * Global full-screen loading overlay state, rendered once by layouts/default.vue
 * via <AppScreenLoader>. Use for whole-screen waits that aren't tied to a single
 * page's data fetch — e.g. switching accounts/households, where the app is about
 * to hard-reload and a per-page skeleton wouldn't show.
 *
 *   const { start, stop } = useScreenLoader()
 *   start('Switching account…')   // show overlay
 *   ...                           // (often followed by a hard navigation)
 *   stop()                        // hide (on error / when no reload happens)
 */
export function useScreenLoader() {
  const show = useState<boolean>('screen-loader:show', () => false)
  const label = useState<string>('screen-loader:label', () => '')

  function start(message = '') {
    label.value = message
    show.value = true
  }
  function stop() {
    show.value = false
  }

  return { show, label, start, stop }
}
